export const getContentFlowIFrameURL = (streamId: string) => {
	return `https://embed.contentflow.net/output/${streamId}`;
};

export const getContentFlowVideoUrl = (videoId: string) => {
	return `https://embed.contentflow.net/media/${videoId}`;
};
